import React from "react";

interface TextareaProps {
  value: any;
  setValue: React.Dispatch<any>;
  name: string;
  placeholder?: string;
}

const Textarea: React.FC<TextareaProps> = ({
  value,
  setValue,
  name,
  placeholder,
}) => {
  return (
    <textarea
      id={name}
      placeholder={placeholder}
      autoComplete="off"
      className="flex-grow p-3 focus:outline-none focus:shadow-outline rounded-lg border resize-none"
      rows={4}
      value={value || ""}
      onChange={(e) => {
        setValue(e.target.value);
      }}
    />
  );
};

export default Textarea;
